import React from 'react'
import { graphql } from 'gatsby'
import {
  Layout,
  Wrapper,
  BannerContainer,
  Billboard,
  Row,
  Column,
  BannerWrapper,
  Section,
  Title,
  GreySection,
  H3,
  SEO,
} from '../components'
import { Map } from '../molecules/about'
import WeChat from '../components/footer/images/wechat.png'
import Phone from '../components/footer/images/phone.png'
import { Anchor } from '../components/footer/atoms'

function About(props) {
  const { data } = props
  return (
    <Layout>
      <SEO
        title='关于我们，云游戏行业整体解决方案商-斗龙云游戏'
        keywords='云游戏解决方案,云游戏整体解决方案商,斗龙云'
        description='斗龙云，游戏厂商和平台的IaaS基础设施和PaaS专业解决方案提供商。深圳市瑞云科技有限公司是国内视觉行业先行者，斗龙云作为瑞云科技旗下核心项目之一，搭载瑞云科技5万+GPU计算资源，200+边缘POP，可为不同需求的用户提供可灵活扩展、高弹性的GPU渲染计算，为云游戏基础设施（IaaS）提供算力保障。'
      />
      <BannerContainer height={720} mobileHeight={360}>
        <BannerWrapper style={{ alignItems: 'center' }}>
          <h1>斗龙云</h1>
          <p>视觉云计算平台</p>
        </BannerWrapper>
        <Billboard fluid={data.banner.childImageSharp.fluid} />
      </BannerContainer>
      <Section>
        <Wrapper>
          <Title style={{ textAlign: 'left' }}>关于我们</Title>
          <p>
            斗龙云，游戏厂商和平台的IaaS基础设施和PaaS专业解决方案提供商。深圳市瑞云科技有限公司是国内视觉行业先行者，斗龙云作为瑞云科技旗下核心项目之一，搭载瑞云科技5万+GPU计算资源，200+边缘POP，可为不同需求的用户提供可灵活扩展、高弹性的GPU渲染计算，为云游戏基础设施（IaaS）提供算力保障。
          </p>
          <p>
            斗龙云深耕核心技术和专业服务，在虚拟化、容器、音视频编解码及实时推流技术等云游戏实施技术上做出重大突破，其自研的低时延串流技术已达业界领先水平。斗龙云的专业PaaS解决方案，为云游戏开发商能够将游戏迅速上云，优化流程减少工作量，降低大型游戏的使用门槛，为厂商和平台提供极具性价比的上云服务，让用户专注于游戏内容的创新，大大提高开发效率，推动整个云游戏产业快速发展！
          </p>
          <p>
            深圳市瑞云科技有限公司作为国内视觉行业垂直云计算SaaS服务领军企业，服务覆盖全球50多个国家200多个地区。瑞云科技以提供优质云服务为宗旨，专注视觉渲染、云计算服务，拥有强大GPU计算能力的自建基础设施平台和经验丰富的技术团队，为全球用户提供多元化、全方位云服务。
          </p>
          <p>斗龙云，让云游戏触手可及。</p>
        </Wrapper>
      </Section>
      <GreySection>
        <Wrapper>
          <Title>联系我们</Title>
          <Row>
            <Column xs='12' lg='6'>
              <H3>深圳市瑞云科技有限公司</H3>
              <p>
                深圳全球总部:
                <br />
                深圳市南山区商华路2号阳光科创中心B座17层
              </p>
              <Row>
                <Column xs='6'>
                  <H3>黄先生</H3>
                  <Anchor href='tel:13760300650'>
                    <img src={Phone} alt='' /> 13760300650
                  </Anchor>
                  <p>
                    <img src={WeChat} alt='' /> 13760300650
                  </p>
                </Column>
                <Column xs='6'>
                  <H3>肖先生</H3>
                  <Anchor href='tel:18681593969'>
                    <img src={Phone} alt='' /> 18681593969
                  </Anchor>
                  <p>
                    <img src={WeChat} alt='' /> 18681593969
                  </p>
                </Column>
              </Row>
            </Column>
            <Column xs='12' lg='6'>
              <Map />
            </Column>
          </Row>
        </Wrapper>
      </GreySection>
    </Layout>
  )
}

export default About

export const query = graphql`
  query {
    banner: file(relativePath: { regex: "/about/banner.png/" }) {
      ...fluidImage
    }
  }
`
